import React, { useEffect } from "react";
import Header from "../../Components/Header";
import SuccessMessage from "../../Components/Notification/SuccessMessage";
import ErrorMessage from "../../Components/Notification/ErrorMessage";
import ApplicationForm from "../../Components/Partners/ApplicationForm";
import PartnerHero from "../../assets/logo/partner-hero.svg";
import UniCard from "../../Components/Partners/UniCard";
import { LocalUni, OverseasUni, UniImage } from "../../Data/Partners";
import PartnerCard from "../../Components/Partners/PartnerCard";
import ImageCarousel from "../../Components/Partners/ImageCarousel";

export default function Partners() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />
      <div className="flex flex-col gap-20">
        <div
          className="relative flex items-center h-screen bg-cover"
          style={{ backgroundImage: `url(${PartnerHero})` }}
        >
          <div className="absolute inset-0 bg-radial from-pink-200/60 via-pink-200/60 to-amber-200/60"></div>
          {/* <div className="flex items-center h-screen bg-radial from-amber-100 via-amber-100 to-pink-200"> */}
          <div className="relative flex flex-row items-center justify-center mx-auto w-[1024px] gap-4 text-[#1A1A1A] [text-shadow:2px_2px_4px_rgba(0,0,0,0.35)]">
            <div className="flex flex-col gap-10 w-1/2">
              <div className="flex flex-col justify-center gap-2">
                <h3 className="font-semibold text-lg underline ">
                  Want to get more deals?
                </h3>
                <h1 className="text-7xl font-extrabold uppercase">
                  Our Partner Universities
                </h1>
                <p className="">
                  Study locally or overseas? Get more deals from our partnership
                  universities!
                </p>
              </div>
              <div className="flex flex-row gap-8">
                <button
                  onClick={() => {
                    const el = document.getElementById("local");
                    if (el) {
                      const yOffset = -100; // scroll 40px above the element
                      const y =
                        el.getBoundingClientRect().top +
                        window.pageYOffset +
                        yOffset;

                      window.scrollTo({ top: y, behavior: "smooth" });
                    }
                  }}
                  className="bg-amber-400 text-lg font-semibold p-4 rounded-lg w-56 cursor-pointer hover:scale-105 duration-300"
                >
                  Local university
                </button>
                <button
                  onClick={() => {
                    const el = document.getElementById("overseas");
                    if (el) {
                      const yOffset = -100; // scroll 40px above the element
                      const y =
                        el.getBoundingClientRect().top +
                        window.pageYOffset +
                        yOffset;

                      window.scrollTo({ top: y, behavior: "smooth" });
                    }
                  }}
                  className="bg-amber-400 text-lg font-semibold p-4 rounded-lg w-56 cursor-pointer hover:scale-105 duration-300"
                >
                  Overseas university
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-6 mx-auto lg:max-w-[1024px]">
          <h3 className="text-4xl font-bold">Intro</h3>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit.
            Necessitatibus officia quas in tenetur optio, soluta ab modi
            quibusdam, dolor inventore earum, fugiat eius et blanditiis iure
            fuga debitis. Nam, tempora.
          </p>
          <ImageCarousel images={UniImage} />
        </div>

        <div
          id="local"
          className="flex flex-col gap-6 mx-auto lg:max-w-[1024px]"
        >
          <div className="flex flex-col gap-2">
            <h3 className="text-4xl font-bold underline decoration-double decoration-amber-400">
              Local Partner Universities
            </h3>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Amet sed
              sit libero! Alias aut hic, provident, ad, voluptate pariatur
              quisquam nisi ex cupiditate autem esse magnam facere eum
              voluptatibus quidem!
            </p>
          </div>
          <div className="w-full">
            <PartnerCard partners={LocalUni} />
          </div>
        </div>

        <div
          id="overseas"
          className="flex flex-col gap-6 mx-auto lg:max-w-[1024px]"
        >
          <div className="flex flex-col gap-2">
            <h3 className="text-4xl font-bold underline decoration-double decoration-amber-400">
              Overseas Partner Universities
            </h3>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Amet sed
              sit libero! Alias aut hic, provident, ad, voluptate pariatur
              quisquam nisi ex cupiditate autem esse magnam facere eum
              voluptatibus quidem!
            </p>
          </div>
          <div className="w-full">
            <PartnerCard partners={OverseasUni} />
          </div>
        </div>

        <div className="flex flex-col gap-6 mx-auto lg:max-w-[1024px]">
          <div className="flex flex-col gap-2">
            <h3 className="text-4xl font-bold">Application Form</h3>
            <p>Choose your interested university to reserve the deals now!</p>
          </div>
          <ApplicationForm />
        </div>
      </div>
    </div>
  );
}
